// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".credit-card__bin .pay-icon{margin:-2px 0}.credit-card__name input{text-transform:uppercase}.credit-card__loading{position:absolute;width:95%;height:80%;display:flex;align-items:center;justify-content:center;background-color:var(--white);opacity:.8;z-index:1}", ""]);
// Exports
module.exports = exports;
